import { toDomPrecision } from '@tldraw/tldraw'
import classNames from 'classnames'
import { ResizeHandlesProps } from './Types'

export const ResizeHandles = ({
  hideTopLeftCorner,
  hideTopRightCorner,
  hideBottomRightCorner,
  hideBottomLeftCorner,
  hideHorizontalEdgeHandles,
  hideVerticalEdgeHandles,
  zoom,
  width,
  height,
}: ResizeHandlesProps) => {
  const cornerSize = 20 / zoom
  const edgeSizeW = 25 / zoom
  const edgeSizeH = 15 / zoom

  return (
    <>
      <svg
        data-testid="selection.resize.top-left"
        className={classNames({
          'tl-hidden': hideTopLeftCorner,
        })}
        aria-label="top_left handle"
        x={toDomPrecision(0 - cornerSize / 3)}
        y={toDomPrecision(0 - cornerSize / 3)}
        width={toDomPrecision(cornerSize)}
        height={toDomPrecision(cornerSize)}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="path-1-inside-1_10079_144272" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 5.5C20 8.53757 17.5376 11 14.5 11L11 11L11 14.5C11 17.5376 8.53757 20 5.5 20C2.46243 20 1.07636e-07 17.5376 2.40413e-07 14.5L6.33815e-07 5.5C7.66591e-07 2.46243 2.46243 -7.66591e-07 5.5 -6.33815e-07L14.5 -2.40413e-07C17.5376 -1.07636e-07 20 2.46243 20 5.5Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 5.5C20 8.53757 17.5376 11 14.5 11L11 11L11 14.5C11 17.5376 8.53757 20 5.5 20C2.46243 20 1.07636e-07 17.5376 2.40413e-07 14.5L6.33815e-07 5.5C7.66591e-07 2.46243 2.46243 -7.66591e-07 5.5 -6.33815e-07L14.5 -2.40413e-07C17.5376 -1.07636e-07 20 2.46243 20 5.5Z"
          fill="white"
        />
        <path
          d="M14.5 11L14.5 12L14.5 11ZM11 11L10 11L10 10L11 10L11 11ZM11 14.5L10 14.5L11 14.5ZM5.5 -6.33815e-07L5.5 -1L5.5 -6.33815e-07ZM14.5 -2.40413e-07L14.5 1L14.5 -2.40413e-07ZM14.5 10C16.9853 10 19 7.98528 19 5.5L21 5.5C21 9.08985 18.0899 12 14.5 12L14.5 10ZM11 10L14.5 10L14.5 12L11 12L11 10ZM10 14.5L10 11L12 11L12 14.5L10 14.5ZM5.5 19C7.98528 19 10 16.9853 10 14.5L12 14.5C12 18.0898 9.08985 21 5.5 21L5.5 19ZM1 14.5C1 16.9853 3.01472 19 5.5 19L5.5 21C1.91015 21 -1 18.0899 -1 14.5L1 14.5ZM1 5.5L1 14.5L-1 14.5L-0.999999 5.5L1 5.5ZM5.5 0.999999C3.01472 0.999999 1 3.01472 1 5.5L-0.999999 5.5C-0.999999 1.91015 1.91015 -1 5.5 -1L5.5 0.999999ZM14.5 1L5.5 0.999999L5.5 -1L14.5 -1L14.5 1ZM19 5.5C19 3.01472 16.9853 1 14.5 1L14.5 -1C18.0899 -1 21 1.91015 21 5.5L19 5.5Z"
          fill="var(--selected-stroke)"
          mask="url(#path-1-inside-1_10079_144272)"
        />
      </svg>
      <svg
        data-testid="selection.resize.top-right"
        className={classNames({
          'tl-hidden': hideTopRightCorner,
        })}
        aria-label="top_right handle"
        x={toDomPrecision(width - cornerSize / 1.5)}
        y={toDomPrecision(0 - cornerSize / 3)}
        width={toDomPrecision(cornerSize)}
        height={toDomPrecision(cornerSize)}
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="path-1-inside-1_10079_144269" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.499999 5.5C0.499999 8.53757 2.96243 11 6 11L9.5 11L9.5 14.5C9.5 17.5376 11.9624 20 15 20C18.0376 20 20.5 17.5376 20.5 14.5L20.5 5.5C20.5 2.46243 18.0376 -7.66591e-07 15 -6.33815e-07L6 -2.40413e-07C2.96243 -1.07636e-07 0.499999 2.46243 0.499999 5.5Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.499999 5.5C0.499999 8.53757 2.96243 11 6 11L9.5 11L9.5 14.5C9.5 17.5376 11.9624 20 15 20C18.0376 20 20.5 17.5376 20.5 14.5L20.5 5.5C20.5 2.46243 18.0376 -7.66591e-07 15 -6.33815e-07L6 -2.40413e-07C2.96243 -1.07636e-07 0.499999 2.46243 0.499999 5.5Z"
          fill="white"
        />
        <path
          d="M6 11L6 12L6 11ZM9.5 11L10.5 11L10.5 10L9.5 10L9.5 11ZM15 -6.33815e-07L15 -1L15 -6.33815e-07ZM6 -2.40413e-07L6 1L6 -2.40413e-07ZM6 10C3.51472 10 1.5 7.98528 1.5 5.5L-0.500001 5.5C-0.5 9.08985 2.41015 12 6 12L6 10ZM9.5 10L6 10L6 12L9.5 12L9.5 10ZM10.5 14.5L10.5 11L8.5 11L8.5 14.5L10.5 14.5ZM15 19C12.5147 19 10.5 16.9853 10.5 14.5L8.5 14.5C8.5 18.0898 11.4101 21 15 21L15 19ZM19.5 14.5C19.5 16.9853 17.4853 19 15 19L15 21C18.5898 21 21.5 18.0899 21.5 14.5L19.5 14.5ZM19.5 5.5L19.5 14.5L21.5 14.5L21.5 5.5L19.5 5.5ZM15 0.999999C17.4853 0.999999 19.5 3.01472 19.5 5.5L21.5 5.5C21.5 1.91015 18.5899 -1 15 -1L15 0.999999ZM6 1L15 0.999999L15 -1L6 -1L6 1ZM1.5 5.5C1.5 3.01472 3.51472 1 6 1L6 -1C2.41015 -1 -0.500001 1.91015 -0.500001 5.5L1.5 5.5Z"
          fill="var(--selected-stroke)"
          mask="url(#path-1-inside-1_10079_144269)"
        />
      </svg>
      <svg
        data-testid="selection.resize.bottom-right"
        className={classNames({
          'tl-hidden': hideBottomRightCorner,
        })}
        aria-label="bottom_right handle"
        x={toDomPrecision(width - cornerSize / 1.5)}
        y={toDomPrecision(height - cornerSize / 1.5)}
        width={toDomPrecision(cornerSize)}
        height={toDomPrecision(cornerSize)}
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="path-1-inside-1_10079_144263" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 0C11.9624 0 9.5 2.46243 9.5 5.5V9H6C2.96243 9 0.5 11.4624 0.5 14.5C0.5 17.5376 2.96243 20 6 20H15C18.0376 20 20.5 17.5376 20.5 14.5V5.5C20.5 2.46243 18.0376 0 15 0Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 0C11.9624 0 9.5 2.46243 9.5 5.5V9H6C2.96243 9 0.5 11.4624 0.5 14.5C0.5 17.5376 2.96243 20 6 20H15C18.0376 20 20.5 17.5376 20.5 14.5V5.5C20.5 2.46243 18.0376 0 15 0Z"
          fill="white"
        />
        <path
          d="M9.5 9V10H10.5V9H9.5ZM10.5 5.5C10.5 3.01472 12.5147 1 15 1V-1C11.4101 -1 8.5 1.91015 8.5 5.5H10.5ZM10.5 9V5.5H8.5V9H10.5ZM6 10H9.5V8H6V10ZM1.5 14.5C1.5 12.0147 3.51472 10 6 10V8C2.41015 8 -0.5 10.9101 -0.5 14.5H1.5ZM6 19C3.51472 19 1.5 16.9853 1.5 14.5H-0.5C-0.5 18.0898 2.41015 21 6 21V19ZM15 19H6V21H15V19ZM19.5 14.5C19.5 16.9853 17.4853 19 15 19V21C18.5898 21 21.5 18.0899 21.5 14.5H19.5ZM19.5 5.5V14.5H21.5V5.5H19.5ZM15 1C17.4853 1 19.5 3.01472 19.5 5.5H21.5C21.5 1.91015 18.5898 -1 15 -1V1Z"
          fill="var(--selected-stroke)"
          mask="url(#path-1-inside-1_10079_144263)"
        />
      </svg>
      <svg
        data-testid="selection.resize.bottom-left"
        className={classNames({
          'tl-hidden': hideBottomLeftCorner,
        })}
        aria-label="bottom_left handle"
        x={toDomPrecision(0 - cornerSize / 3)}
        y={toDomPrecision(height - cornerSize / 1.5)}
        width={toDomPrecision(cornerSize)}
        height={toDomPrecision(cornerSize)}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="path-1-inside-1_10079_144266" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 0C9.03757 0 11.5 2.46243 11.5 5.5V9H15C18.0376 9 20.5 11.4624 20.5 14.5C20.5 17.5376 18.0376 20 15 20H6C2.96243 20 0.5 17.5376 0.5 14.5V5.5C0.5 2.46243 2.96243 0 6 0Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 0C9.03757 0 11.5 2.46243 11.5 5.5V9H15C18.0376 9 20.5 11.4624 20.5 14.5C20.5 17.5376 18.0376 20 15 20H6C2.96243 20 0.5 17.5376 0.5 14.5V5.5C0.5 2.46243 2.96243 0 6 0Z"
          fill="white"
        />
        <path
          d="M11.5 9V10H10.5V9H11.5ZM10.5 5.5C10.5 3.01472 8.48528 1 6 1V-1C9.58985 -1 12.5 1.91015 12.5 5.5H10.5ZM10.5 9V5.5H12.5V9H10.5ZM15 10H11.5V8H15V10ZM19.5 14.5C19.5 12.0147 17.4853 10 15 10V8C18.5899 8 21.5 10.9101 21.5 14.5H19.5ZM15 19C17.4853 19 19.5 16.9853 19.5 14.5H21.5C21.5 18.0898 18.5899 21 15 21V19ZM6 19H15V21H6V19ZM1.5 14.5C1.5 16.9853 3.51472 19 6 19V21C2.41015 21 -0.5 18.0899 -0.5 14.5H1.5ZM1.5 5.5V14.5H-0.5V5.5H1.5ZM6 1C3.51472 1 1.5 3.01472 1.5 5.5H-0.5C-0.5 1.91015 2.41015 -1 6 -1V1Z"
          fill="var(--selected-stroke)"
          mask="url(#path-1-inside-1_10079_144266)"
        />
      </svg>

      <svg
        data-testid="selection.resize.top"
        className={classNames({
          'tl-hidden': hideVerticalEdgeHandles,
        })}
        x={toDomPrecision((width - edgeSizeW) / 2)}
        y={toDomPrecision(0 - edgeSizeH / 2)}
        width={toDomPrecision(edgeSizeW)}
        height={toDomPrecision(edgeSizeH)}
        viewBox="0 0 25 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="path-1-inside-1_10079_144279" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.32222 11.8363C2.84101 14.4669 6.20476 15.3682 8.83536 13.8494L12.3946 11.7945L15.8253 13.7752C18.4559 15.294 21.8196 14.3927 23.3384 11.762C24.8572 9.13144 23.9559 5.76769 21.3253 4.24891L15.2631 0.748908C14.0018 0.0206967 12.572 -0.151153 11.2578 0.157211C10.6201 0.261602 9.99023 0.480941 9.39754 0.823127L3.33536 4.32313C0.704755 5.84191 -0.196558 9.20566 1.32222 11.8363Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.32222 11.8363C2.84101 14.4669 6.20476 15.3682 8.83536 13.8494L12.3946 11.7945L15.8253 13.7752C18.4559 15.294 21.8196 14.3927 23.3384 11.762C24.8572 9.13144 23.9559 5.76769 21.3253 4.24891L15.2631 0.748908C14.0018 0.0206967 12.572 -0.151153 11.2578 0.157211C10.6201 0.261602 9.99023 0.480941 9.39754 0.823127L3.33536 4.32313C0.704755 5.84191 -0.196558 9.20566 1.32222 11.8363Z"
          fill="white"
        />
        <path
          d="M8.83536 13.8494L8.33536 12.9834L8.83536 13.8494ZM1.32222 11.8363L2.18825 11.3363L2.18825 11.3363L1.32222 11.8363ZM12.3946 11.7945L12.8946 10.9285L12.3946 10.6398L11.8946 10.9285L12.3946 11.7945ZM15.8253 13.7752L15.3253 14.6412L15.3253 14.6412L15.8253 13.7752ZM23.3384 11.762L22.4724 11.262L22.4724 11.262L23.3384 11.762ZM21.3253 4.24891L20.8253 5.11493L21.3253 4.24891ZM15.2631 0.748908L14.7631 1.61493L14.7631 1.61493L15.2631 0.748908ZM11.2578 0.157211L11.4193 1.14407L11.453 1.13856L11.4862 1.13077L11.2578 0.157211ZM9.39754 0.823127L8.89754 -0.0429001L8.89754 -0.0428988L9.39754 0.823127ZM3.33536 4.32313L3.83536 5.18915L3.83536 5.18915L3.33536 4.32313ZM8.33536 12.9834C6.18305 14.226 3.43089 13.4886 2.18825 11.3363L0.4562 12.3363C2.25112 15.4452 6.22646 16.5104 9.33537 14.7154L8.33536 12.9834ZM11.8946 10.9285L8.33536 12.9834L9.33536 14.7154L12.8946 12.6605L11.8946 10.9285ZM16.3253 12.9092L12.8946 10.9285L11.8946 12.6605L15.3253 14.6412L16.3253 12.9092ZM22.4724 11.262C21.2298 13.4144 18.4776 14.1518 16.3253 12.9092L15.3253 14.6412C18.4342 16.4361 22.4095 15.3709 24.2044 12.262L22.4724 11.262ZM20.8253 5.11493C22.9776 6.35757 23.715 9.10973 22.4724 11.262L24.2044 12.262C25.9994 9.15314 24.9342 5.17781 21.8253 3.38288L20.8253 5.11493ZM14.7631 1.61493L20.8253 5.11493L21.8253 3.38288L15.7631 -0.117117L14.7631 1.61493ZM11.4862 1.13077C12.5626 0.878202 13.7307 1.01888 14.7631 1.61493L15.7631 -0.117117C14.2729 -0.977488 12.5813 -1.18051 11.0293 -0.81635L11.4862 1.13077ZM9.89754 1.68915C10.384 1.40827 10.899 1.22925 11.4193 1.14407L11.0962 -0.829652C10.3412 -0.706048 9.59641 -0.446391 8.89754 -0.0429001L9.89754 1.68915ZM3.83536 5.18915L9.89754 1.68915L8.89754 -0.0428988L2.83536 3.4571L3.83536 5.18915ZM2.18825 11.3363C0.945609 9.18395 1.68305 6.43179 3.83536 5.18915L2.83536 3.4571C-0.273539 5.25203 -1.33873 9.22737 0.4562 12.3363L2.18825 11.3363Z"
          fill="var(--selected-stroke)"
          mask="url(#path-1-inside-1_10079_144279)"
        />
      </svg>
      <svg
        data-testid="selection.resize.right"
        className={classNames({
          'tl-hidden': hideHorizontalEdgeHandles,
        })}
        x={toDomPrecision(width - edgeSizeH / 2)}
        y={toDomPrecision((height - edgeSizeW) / 2)}
        width={toDomPrecision(edgeSizeH)}
        height={toDomPrecision(edgeSizeW)}
        viewBox="0 0 15 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="path-1-inside-1_10079_144275" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.16251 1.32247C0.531903 2.84125 -0.369411 6.205 1.14937 8.83561L3.27949 12.5251L1.37398 15.8255C-0.144801 18.4561 0.756513 21.8199 3.38712 23.3387C6.01773 24.8574 9.38148 23.9561 10.9003 21.3255L14.4003 15.2633C15.486 13.3828 15.335 11.1276 14.1996 9.43961C14.1917 9.42565 14.1837 9.41171 14.1756 9.39779L10.6757 3.33561C9.15687 0.705002 5.79312 -0.196311 3.16251 1.32247Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.16251 1.32247C0.531903 2.84125 -0.369411 6.205 1.14937 8.83561L3.27949 12.5251L1.37398 15.8255C-0.144801 18.4561 0.756513 21.8199 3.38712 23.3387C6.01773 24.8574 9.38148 23.9561 10.9003 21.3255L14.4003 15.2633C15.486 13.3828 15.335 11.1276 14.1996 9.43961C14.1917 9.42565 14.1837 9.41171 14.1756 9.39779L10.6757 3.33561C9.15687 0.705002 5.79312 -0.196311 3.16251 1.32247Z"
          fill="white"
        />
        <path
          d="M1.14937 8.83561L2.0154 8.33561L1.14937 8.83561ZM3.16251 1.32247L3.66251 2.1885L3.66251 2.1885L3.16251 1.32247ZM3.27949 12.5251L4.14552 13.0251L4.43419 12.5251L4.14552 12.0251L3.27949 12.5251ZM1.37398 15.8255L0.507956 15.3255L0.507956 15.3255L1.37398 15.8255ZM3.38712 23.3387L3.88712 22.4726L3.38712 23.3387ZM10.9003 21.3255L11.7663 21.8255L11.7663 21.8255L10.9003 21.3255ZM14.4003 15.2633L15.2663 15.7633L15.2663 15.7633L14.4003 15.2633ZM14.1996 9.43961L13.3293 9.93212L13.3483 9.96571L13.3698 9.99773L14.1996 9.43961ZM14.1756 9.39779L13.3096 9.89779L13.3096 9.89781L14.1756 9.39779ZM10.6757 3.33561L9.80963 3.83561L10.6757 3.33561ZM2.0154 8.33561C0.772757 6.18329 1.5102 3.43114 3.66251 2.1885L2.66251 0.456446C-0.44639 2.25137 -1.51158 6.22671 0.283347 9.33561L2.0154 8.33561ZM4.14552 12.0251L2.0154 8.33561L0.283347 9.33561L2.41347 13.0251L4.14552 12.0251ZM2.24001 16.3255L4.14552 13.0251L2.41347 12.0251L0.507956 15.3255L2.24001 16.3255ZM3.88712 22.4726C1.73481 21.23 0.997367 18.4778 2.24001 16.3255L0.507956 15.3255C-1.28697 18.4344 -0.22178 22.4098 2.88712 24.2047L3.88712 22.4726ZM10.0342 20.8255C8.7916 22.9778 6.03944 23.7153 3.88712 22.4726L2.88712 24.2047C5.99602 25.9996 9.97136 24.9344 11.7663 21.8255L10.0342 20.8255ZM13.5342 14.7633L10.0342 20.8255L11.7663 21.8255L15.2663 15.7633L13.5342 14.7633ZM13.3698 9.99773C14.3003 11.381 14.4218 13.226 13.5342 14.7633L15.2663 15.7633C16.5502 13.5396 16.3697 10.8742 15.0293 8.88149L13.3698 9.99773ZM13.3096 9.89781C13.3162 9.90925 13.3228 9.92068 13.3293 9.93212L15.0699 8.94711C15.0605 8.93062 15.0511 8.91417 15.0417 8.89776L13.3096 9.89781ZM9.80963 3.83561L13.3096 9.89779L15.0417 8.89779L11.5417 2.83561L9.80963 3.83561ZM3.66251 2.1885C5.81483 0.945856 8.56698 1.68329 9.80963 3.83561L11.5417 2.83561C9.74675 -0.273291 5.77141 -1.33848 2.66251 0.456446L3.66251 2.1885Z"
          fill="var(--selected-stroke)"
          mask="url(#path-1-inside-1_10079_144275)"
        />
      </svg>
      <svg
        data-testid="selection.resize.bottom"
        className={classNames({
          'tl-hidden': hideVerticalEdgeHandles,
        })}
        x={toDomPrecision((width - edgeSizeW) / 2)}
        y={toDomPrecision(height - edgeSizeH / 2)}
        width={toDomPrecision(edgeSizeW)}
        height={toDomPrecision(edgeSizeH)}
        viewBox="0 0 25 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="path-1-inside-1_10079_144283" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.32222 3.16373C2.84101 0.533124 6.20476 -0.368189 8.83536 1.15059L12.3946 3.20552L15.8253 1.22481C18.4559 -0.29397 21.8196 0.607344 23.3384 3.23795C24.8572 5.86856 23.9559 9.23231 21.3253 10.7511L15.2631 14.2511C14.0018 14.9793 12.572 15.1512 11.2578 14.8428C10.6201 14.7384 9.99023 14.5191 9.39754 14.1769L3.33536 10.6769C0.704755 9.15809 -0.196558 5.79434 1.32222 3.16373Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.32222 3.16373C2.84101 0.533124 6.20476 -0.368189 8.83536 1.15059L12.3946 3.20552L15.8253 1.22481C18.4559 -0.29397 21.8196 0.607344 23.3384 3.23795C24.8572 5.86856 23.9559 9.23231 21.3253 10.7511L15.2631 14.2511C14.0018 14.9793 12.572 15.1512 11.2578 14.8428C10.6201 14.7384 9.99023 14.5191 9.39754 14.1769L3.33536 10.6769C0.704755 9.15809 -0.196558 5.79434 1.32222 3.16373Z"
          fill="white"
        />
        <path
          d="M8.83536 1.15059L8.33536 2.01662L8.83536 1.15059ZM1.32222 3.16373L2.18825 3.66373L2.18825 3.66373L1.32222 3.16373ZM12.3946 3.20552L12.8946 4.07154L12.3946 4.36022L11.8946 4.07154L12.3946 3.20552ZM15.8253 1.22481L15.3253 0.358787L15.3253 0.358787L15.8253 1.22481ZM23.3384 3.23795L22.4724 3.73795L22.4724 3.73795L23.3384 3.23795ZM21.3253 10.7511L20.8253 9.88507L21.3253 10.7511ZM15.2631 14.2511L14.7631 13.3851L14.7631 13.3851L15.2631 14.2511ZM11.2578 14.8428L11.4193 13.8559L11.453 13.8614L11.4862 13.8692L11.2578 14.8428ZM9.39754 14.1769L8.89754 15.0429L8.89754 15.0429L9.39754 14.1769ZM3.33536 10.6769L3.83536 9.81085L3.83536 9.81085L3.33536 10.6769ZM8.33536 2.01662C6.18305 0.773978 3.43089 1.51142 2.18825 3.66373L0.4562 2.66373C2.25112 -0.445169 6.22646 -1.51036 9.33537 0.284569L8.33536 2.01662ZM11.8946 4.07154L8.33536 2.01662L9.33536 0.284569L12.8946 2.33949L11.8946 4.07154ZM16.3253 2.09084L12.8946 4.07154L11.8946 2.33949L15.3253 0.358787L16.3253 2.09084ZM22.4724 3.73795C21.2298 1.58564 18.4776 0.848198 16.3253 2.09084L15.3253 0.358787C18.4342 -1.43614 22.4095 -0.370948 24.2044 2.73795L22.4724 3.73795ZM20.8253 9.88507C22.9776 8.64243 23.715 5.89027 22.4724 3.73795L24.2044 2.73795C25.9994 5.84686 24.9342 9.82219 21.8253 11.6171L20.8253 9.88507ZM14.7631 13.3851L20.8253 9.88507L21.8253 11.6171L15.7631 15.1171L14.7631 13.3851ZM11.4862 13.8692C12.5626 14.1218 13.7307 13.9811 14.7631 13.3851L15.7631 15.1171C14.2729 15.9775 12.5813 16.1805 11.0293 15.8163L11.4862 13.8692ZM9.89754 13.3108C10.384 13.5917 10.899 13.7707 11.4193 13.8559L11.0962 15.8297C10.3412 15.706 9.59641 15.4464 8.89754 15.0429L9.89754 13.3108ZM3.83536 9.81085L9.89754 13.3108L8.89754 15.0429L2.83536 11.5429L3.83536 9.81085ZM2.18825 3.66373C0.945609 5.81605 1.68305 8.56821 3.83536 9.81085L2.83536 11.5429C-0.273539 9.74797 -1.33873 5.77263 0.4562 2.66373L2.18825 3.66373Z"
          fill="var(--selected-stroke)"
          mask="url(#path-1-inside-1_10079_144283)"
        />
      </svg>
      <svg
        data-testid="selection.resize.left"
        className={classNames({
          'tl-hidden': hideHorizontalEdgeHandles,
        })}
        x={toDomPrecision(0 - edgeSizeH / 2)}
        y={toDomPrecision((height - edgeSizeW) / 2)}
        width={toDomPrecision(edgeSizeH)}
        height={toDomPrecision(edgeSizeW)}
        viewBox="0 0 16 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="path-1-inside-1_10079_144287" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.8375 1.32247C15.4681 2.84125 16.3694 6.205 14.8506 8.83561L12.7205 12.5251L14.626 15.8255C16.1448 18.4561 15.2435 21.8199 12.6129 23.3387C9.98227 24.8574 6.61852 23.9561 5.09974 21.3255L1.59974 15.2633C0.514014 13.3828 0.665036 11.1276 1.80044 9.43961C1.80834 9.42565 1.81631 9.41171 1.82435 9.39779L5.32435 3.33561C6.84313 0.705002 10.2069 -0.196311 12.8375 1.32247Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.8375 1.32247C15.4681 2.84125 16.3694 6.205 14.8506 8.83561L12.7205 12.5251L14.626 15.8255C16.1448 18.4561 15.2435 21.8199 12.6129 23.3387C9.98227 24.8574 6.61852 23.9561 5.09974 21.3255L1.59974 15.2633C0.514014 13.3828 0.665036 11.1276 1.80044 9.43961C1.80834 9.42565 1.81631 9.41171 1.82435 9.39779L5.32435 3.33561C6.84313 0.705002 10.2069 -0.196311 12.8375 1.32247Z"
          fill="white"
        />
        <path
          d="M14.8506 8.83561L13.9846 8.33561L14.8506 8.83561ZM12.8375 1.32247L12.3375 2.1885L12.3375 2.1885L12.8375 1.32247ZM12.7205 12.5251L11.8545 13.0251L11.5658 12.5251L11.8545 12.0251L12.7205 12.5251ZM14.626 15.8255L15.492 15.3255L15.492 15.3255L14.626 15.8255ZM12.6129 23.3387L12.1129 22.4726L12.6129 23.3387ZM5.09974 21.3255L4.23371 21.8255L4.23371 21.8255L5.09974 21.3255ZM1.59974 15.2633L0.733713 15.7633L0.733713 15.7633L1.59974 15.2633ZM1.80044 9.43961L2.67075 9.93212L2.65174 9.96571L2.6302 9.99773L1.80044 9.43961ZM1.82435 9.39779L2.69038 9.89779L2.69036 9.89781L1.82435 9.39779ZM5.32435 3.33561L6.19037 3.83561L5.32435 3.33561ZM13.9846 8.33561C15.2272 6.18329 14.4898 3.43114 12.3375 2.1885L13.3375 0.456446C16.4464 2.25137 17.5116 6.22671 15.7167 9.33561L13.9846 8.33561ZM11.8545 12.0251L13.9846 8.33561L15.7167 9.33561L13.5865 13.0251L11.8545 12.0251ZM13.76 16.3255L11.8545 13.0251L13.5865 12.0251L15.492 15.3255L13.76 16.3255ZM12.1129 22.4726C14.2652 21.23 15.0026 18.4778 13.76 16.3255L15.492 15.3255C17.287 18.4344 16.2218 22.4098 13.1129 24.2047L12.1129 22.4726ZM5.96576 20.8255C7.2084 22.9778 9.96056 23.7153 12.1129 22.4726L13.1129 24.2047C10.004 25.9996 6.02864 24.9344 4.23371 21.8255L5.96576 20.8255ZM2.46576 14.7633L5.96576 20.8255L4.23371 21.8255L0.733713 15.7633L2.46576 14.7633ZM2.6302 9.99773C1.69975 11.381 1.57818 13.226 2.46576 14.7633L0.733713 15.7633C-0.550156 13.5396 -0.369676 10.8742 0.97068 8.88149L2.6302 9.99773ZM2.69036 9.89781C2.68376 9.90925 2.67722 9.92068 2.67075 9.93212L0.930133 8.94711C0.939464 8.93062 0.948866 8.91417 0.958337 8.89776L2.69036 9.89781ZM6.19037 3.83561L2.69038 9.89779L0.958324 8.89779L4.45832 2.83561L6.19037 3.83561ZM12.3375 2.1885C10.1852 0.945856 7.43302 1.68329 6.19037 3.83561L4.45832 2.83561C6.25325 -0.273291 10.2286 -1.33848 13.3375 0.456446L12.3375 2.1885Z"
          fill="var(--selected-stroke)"
          mask="url(#path-1-inside-1_10079_144287)"
        />
      </svg>
    </>
  )
}
